import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from './utils/constants';
import { ToastProvider } from 'react-toast-notifications';
import CenteredFallback from './components/commons/CenteredFallback';
import AppErrorBoundary from './components/commons/AppErrorBoundary';

const AuthenticatedAppShell = React.lazy(() => import('./containers/AuthenticatedAppShell'));
const PublicCampaignTerm = React.lazy(() => import('./components/campaigns/CreateCampaign/CampaignTerm/PublicCampaignTerm'));
const CampaignLanding = React.lazy(() => import('./pages/CampaignLanding'));

function App() {
  useEffect(() => {
    const setAppHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--app-vh', `${vh}px`);
    };

    setAppHeight();
    window.addEventListener('resize', setAppHeight);
    return () => window.removeEventListener('resize', setAppHeight);
  }, []);

  return (
    <React.Fragment>
      <GlobalStyle />
      <ToastProvider newestOnTop={true}>
        <BrowserRouter>
          <Switch>
            <Route path={PUBLIC_ROUTE.campaignLanding} exact>
              <Suspense fallback={<CenteredFallback />}>
                <AppErrorBoundary>
                  <CampaignLanding />
                </AppErrorBoundary>
              </Suspense>
            </Route>
            <Route path={PUBLIC_ROUTE.sharedCampaign} exact>
              <Suspense fallback={<CenteredFallback />}>
                <AppErrorBoundary>
                  <CampaignLanding />
                </AppErrorBoundary>
              </Suspense>
            </Route>
            <Route path={PRIVATE_ROUTE.publishCampaignTerms} exact>
              <Suspense fallback={<CenteredFallback />}>
                <AppErrorBoundary>
                  <PublicCampaignTerm />
                </AppErrorBoundary>
              </Suspense>
            </Route>
            <Route>
              <Suspense fallback={<CenteredFallback />}>
                <AppErrorBoundary>
                  <AuthenticatedAppShell />
                </AppErrorBoundary>
              </Suspense>
            </Route>
          </Switch>
        </BrowserRouter>
      </ToastProvider>
    </React.Fragment>
  );
}

export default App;

const GlobalStyle = createGlobalStyle`
  .react-toast-notifications__container {
    z-index: 1400 !important;
  }
`;
